module.exports = __webpack_public_path__ + "img/icon_tr.66995232.svg";